import { prefix as prefixBase } from '../../constants'
export const prefixTable = `${prefixBase}.table`
export const prefixColumns = `${prefixTable}.columns`
export const prefixActions = `${prefixBase}.actions`

export enum LearningPathsColumns {
  name = 'name',
  lmsProfile = 'lms_profile_name',
  coursesCount = 'courses_count',
  usersCount = 'users_count',
  progress = 'users_finished_percentage',
  userLmsActive = 'monitoring_learning_paths_user_lms_active',
}
